import { render, staticRenderFns } from "./collapse-list.vue?vue&type=template&id=721998d0"
import script from "./collapse-list.vue?vue&type=script&lang=js"
export * from "./collapse-list.vue?vue&type=script&lang=js"
import style0 from "./product-note.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports